import * as SelectPrimitive from "@radix-ui/react-select";

const SelectValue = SelectPrimitive.Value;

export { SelectValue };
